class PdpPromoBanners extends HTMLElement {
  constructor() {
    super();

    // Initialize state variables
    this.toggleOn = false;
    this.activeClubMember = false;
    this.isClubProductInCart = false;
    this.purchaseType = null;
    this.athleticClubMemberProduct = false;
    this.preMembershipSubscriber = false;
    this.employee = false;
    this.isAvailable = true;

    // Initialize DOM element references (will be set in connectedCallback)
    this.bundleUpsellEl = null;
    this.shippingPromoEl = null;
    this.purchaseTypeSubscriptionCalloutEl = null;
    this.pdpPromoClubCalloutEl = null;
    this.manageSubscriptionCalloutEl = null;
    this.bundlePriceEl = null;

    // Bind event handlers
    this.handleMembershipToggle = this.handleMembershipToggle.bind(this);
    this.handleCartUpdateEnriched = this.handleCartUpdateEnriched.bind(this);
    this.handlePurchaseTypeChanged = this.handlePurchaseTypeChanged.bind(this);
  }

  connectedCallback() {
    // Read initial state from attributes
    this.activeClubMember = this.getAttribute('active-club-member') === 'true';
    this.athleticClubMemberProduct = this.getAttribute('athletic-club-member-product') === 'true';
    this.preMembershipSubscriber = this.getAttribute('pre-membership-subscriber') === 'true';
    this.employee = this.getAttribute('employee') === 'true';
    this.isAvailable = this.getAttribute('is-available') === 'true';

    // Query toggle-switch element to get initial club-toggle state
    const toggleSwitch = document.querySelector('toggle-switch');
    if (toggleSwitch) {
      this.toggleOn = toggleSwitch.getAttribute('club-toggle') === 'true';
    }

    // Read initial cart state
    if (window.__abc?.ShopifyCartData?.isClubProductInCart) {
      this.isClubProductInCart = window.__abc.ShopifyCartData.isClubProductInCart;
    }

    // Query pdp-purchase-options for initial purchase type
    const selectedOption = document.querySelector('.selected_pricing_option');
    if (selectedOption) {
      this.purchaseType = selectedOption.getAttribute('data-purchase-type');
    }

    // Cache promo elements
    this._cacheElements();

    // Set up event listeners
    document.addEventListener('pdp-toggle-club-membership', this.handleMembershipToggle);
    window.addEventListener('cartUpdateEnriched', this.handleCartUpdateEnriched);
    document.addEventListener('purchase-type-changed', this.handlePurchaseTypeChanged);

    // Initial update
    this.updatePromoBanners();
  }

  disconnectedCallback() {
    document.removeEventListener('pdp-toggle-club-membership', this.handleMembershipToggle);
    window.removeEventListener('cartUpdateEnriched', this.handleCartUpdateEnriched);
    document.removeEventListener('purchase-type-changed', this.handlePurchaseTypeChanged);
  }

  _cacheElements() {
    this.bundleUpsellEl = document.querySelector('.product-bundle-option');
    this.shippingPromoEl = document.querySelector('.purchase_type_onetime');
    this.purchaseTypeSubscriptionCalloutEl = document.querySelector('.purchase_type_subscription');
    this.pdpPromoClubCalloutEl = document.querySelector('.pdp_promo_club_callout');
    this.manageSubscriptionCalloutEl = document.querySelector('.manage_subscription_callout');
    this.bundlePriceEl = this.bundleUpsellEl?.querySelector('.bundle-price');
  }

  handleMembershipToggle(event) {
    const { active } = event.detail;
    this.toggleOn = active;
    this.updatePromoBanners();
  }

  handleCartUpdateEnriched(event) {
    const { isClubProductInCart } = event.detail;
    this.isClubProductInCart = isClubProductInCart;
    this.updatePromoBanners();
  }

  handlePurchaseTypeChanged(event) {
    const { purchaseType } = event.detail;
    this.purchaseType = purchaseType;
    this.updatePromoBanners();
  }

  updatePromoBanners() {
    if (!this.isAvailable) {
      return;
    }

    // Check if bundle exists
    const bundleExists = !!this.bundleUpsellEl;

    if (bundleExists) {
      // Bundle upsell logic
      const clubToggleOrInCart = this.toggleOn || this.isClubProductInCart;

      if (clubToggleOrInCart) {
        // Hide bundle upsell, show free glass promo
        if (this.bundleUpsellEl) {
          this.bundleUpsellEl.style.display = 'none';
        }
        if (this.pdpPromoClubCalloutEl) {
          this.pdpPromoClubCalloutEl.style.display = 'flex';
        }
        // Hide other promos
        if (this.shippingPromoEl) {
          this.shippingPromoEl.style.display = 'none';
        }
        if (this.purchaseTypeSubscriptionCalloutEl) {
          this.purchaseTypeSubscriptionCalloutEl.style.display = 'none';
        }
      } else {
        // Show bundle upsell (price is already set correctly in Liquid for activeClubMember)
        if (this.bundleUpsellEl) {
          this.bundleUpsellEl.style.display = 'block';
        }
        if (this.pdpPromoClubCalloutEl) {
          this.pdpPromoClubCalloutEl.style.display = 'none';
        }

        // Hide other promos
        if (this.shippingPromoEl) {
          this.shippingPromoEl.style.display = 'none';
        }
        if (this.purchaseTypeSubscriptionCalloutEl) {
          this.purchaseTypeSubscriptionCalloutEl.style.display = 'none';
        }
      }
    } else {
      // No bundle - use existing promo banner logic
      if (this.purchaseType === 'subscribeAndSave') {
        if (!this.toggleOn) {
          if (this.purchaseTypeSubscriptionCalloutEl) {
            this.purchaseTypeSubscriptionCalloutEl.style.display = 'flex';
          }
          if (this.shippingPromoEl) {
            this.shippingPromoEl.style.display = 'none';
          }
        }
      } else {
        // oneTime purchase type
        if (!this.toggleOn) {
          if (this.purchaseTypeSubscriptionCalloutEl) {
            this.purchaseTypeSubscriptionCalloutEl.style.display = 'none';
          }
          if (this.shippingPromoEl) {
            this.shippingPromoEl.style.display = 'flex';
          }
        }
      }

      // Club callout logic
      if (this.toggleOn && !this.activeClubMember) {
        if (this.pdpPromoClubCalloutEl) {
          this.pdpPromoClubCalloutEl.style.display = 'flex';
        }
        if (this.purchaseTypeSubscriptionCalloutEl) {
          this.purchaseTypeSubscriptionCalloutEl.style.display = 'none';
        }
        if (this.shippingPromoEl) {
          this.shippingPromoEl.style.display = 'none';
        }
      } else {
        if (this.pdpPromoClubCalloutEl) {
          this.pdpPromoClubCalloutEl.style.display = 'none';
        }
      }
    }
  }
}

customElements.define('pdp-promo-banners', PdpPromoBanners);
